import { render } from "./ServicesSection.vue?vue&type=template&id=27ee7ac1"
import script from "./ServicesSection.vue?vue&type=script&lang=js"
export * from "./ServicesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__